import { memo, SVGProps } from 'react';
import './LoadingIcon.css';

function LoadingIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 34 44"
      width={32}
      height={32}
      fill="none"
      stroke="#fff"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M25.0866 15.9962C22.7495 14.7514 21.4788 14.5559 18.482 14.057C18.482 8.56832 21.9782 3.07968 21.9782 3.07968C21.9782 3.07968 16.551 4.00486 12.5013 6.57245C9.73842 8.32411 7.14499 10.9895 5.50887 13.558C2.40439 18.0002 1.84278 22.5264 2.03315 26.2641C2.24667 35.0364 9.56734 41.5797 17.5622 41.5797C25.557 41.5797 32 35.3206 32 27.2828C32 21.6166 29.359 18.3599 25.3801 16.1557"
        clipRule="evenodd"
        strokeWidth="4"
        className="_10yn6nq2 _10yn6nq1 _10yn6nq3 _10yn6nq5"
      />
    </svg>
  );
}

export function LoadingIconCard(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <path
        d="M5.00905 19.4763C5.29817 11.1971 12.2442 4.71983 20.5234 5.00894C28.8026 5.29806 35.2799 12.2441 34.9908 20.5233C34.7017 28.8025 27.7556 35.2798 19.4764 34.9907"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default memo(LoadingIcon);
